import React from "react";

const NotesFooter = ({ data }) => {
  const lineItems = data?.lineItems || [];
  const particulars = [...new Set(lineItems.map((i) => i?.particulars))];

  const specialItems = [
    "Practical Hydroponic Training",
    "Hydroponic Masterclass",
    "Virtual Site Inspection",
    "Site Inspection: Expert Personal Visit",
  ];

  const hasDefault = particulars.some((p) => !specialItems.includes(p));

  const termsMap = {
    "Practical Hydroponic Training": [
      "Once your seat is confirmed, it cannot be cancelled or refunded, and rescheduling is not allowed within 48 hours before the training starts.",
      "Any disputes will be handled only under Pune, Maharashtra jurisdiction.",
      "GST and other applicable taxes will be charged as per law.",
      "Training materials and shared information must not be copied or shared without written permission.",
      "Payment of the invoice means you agree to these terms.",
    ],

    "Hydroponic Masterclass": [
      "Once your seat is confirmed, cancellation and refund are allowed only within 7 days from the date of enrollment, after 7 days, no cancellation or refund will be permitted.",
      "Any disputes will be handled only under Pune, Maharashtra jurisdiction.",
      "GST and other applicable taxes will be charged as per law.",
      "Training materials and shared information must not be copied or shared without written permission.",
      "Payment of the invoice means you agree to these terms.",
    ],

    "Virtual Site Inspection": [
      "Site inspections once confirmed are non-cancellable, non-refundable.",
      "All disputes shall be subject to exclusive jurisdiction of Pune, Maharashtra.",
      "GST and all applicable statutory taxes will be charged extra as per law.",
      "Company liability, if any, is limited strictly to the invoice value.",
      "All shared documents, data, and project information shall remain confidential.",
      "Issuance of invoice and/or payment confirms full acceptance of these terms.",
    ],

    "Site Inspection: Expert Personal Visit": [
      "Site inspections once confirmed are non-cancellable, non-refundable, and cannot be rescheduled.",
      "In case of project cancellation, ₹10,000 plus applicable taxes will be deducted towards professional and DPR charges along with actual travel and stay expenses.",
      "Any eligible refund remaining unclaimed beyond the financial year in which the payment was made shall stand forfeited, with no refund being payable thereafter. KBPL shall issue the applicable invoice for all payments received.",
      "In the event the project proceeds, DPR charges of ₹10,000, along with actual travel and stay expenses and applicable GST, shall be payable additionally.",
      "All disputes shall be subject to exclusive jurisdiction of Pune, Maharashtra.",
      "GST and all applicable statutory taxes will be charged extra as per law.",
      "KBPL liability, if any, is limited strictly to the invoice value.",
      "KBPL shall not be liable for delays caused by events beyond reasonable control.",
      "All shared documents, data, and project information shall remain confidential.",
      "Issuance of invoice and/or payment confirms full acceptance of these terms.",
    ],
  };

  // Collect and dedupe special terms
  const specialTerms = [
    ...new Set(particulars.flatMap((p) => termsMap[p] || [])),
  ];

  const defaultTerms = hasDefault
    ? [
        "All prices are in INR.",
        "Work will start after advance payment.",
        "Advance shall be treated as work order.",
        "Rates are based on current steel and PVC raw material prices.",
        "Transportation and labour ticket charges are extra.",
        "Any additional services will be charged separately.",
      ]
    : [];

  const quotationTerms =
    data?.invoiceType === "quotation"
      ? [
          "This quote is subject to the Sale Conditions listed below. KBPL will not be bound by any revisions, alterations, or additions to these terms, even if they are included in your proposal acceptance, unless specifically agreed in writing.",
          "Each project is customized to your needs and specifications. Any extra work after handover requires a separate work order. It's your responsibility to request changes before handover.",
          "KBPL may provide excess material to prevent short-term shortages. This material will remain on site until the project is completed and must be returned to KBPL or its authorized representative.",
          "Site should be clean, clear and to be maintained at zero level to carry-forward immediate construction.",
          "Once work-order is received and work has started, the amount received is non-refundable.",
          "Advance will be considered as work order.",
          "The warranty specified in the quotation is a condensed version of the warranty document. Please read the warranty document for more information on the claim process and warranty coverage.",
          "In case of deep foundation, provision of drilling/auger machine/other needed means to be facilitated by you if required. Soil knowledge should be provided by you",
          "Seeds, nutrients and other operational agronomy tools to be procured by you.",
          "You must provide housing, transportation, groceries, and drinking water for laborers on the field.",
          "For supervisor or office representatives / Agronomist as and when they visit, accommodation with food in resident/ guest house/ hotel facility to be provided by you to nearby site.",
          "For site development requirement of electricity or generator and water on field to be provided by you.",
          "Civil materials & civil work tools required for the project is your responsibility.",
          "KBPL is not responsible for missing, damaged, loss and theft of materials after delivery.",
          "If work is delayed or stopped due to on-site issues, you will incur additional costs.",
          "Transportation of goods & labours ex factory to the site location charges are extra. Any extra services will be charged additionally.",
          "Insurance of project during and after construction is as per your preference. We strongly suggest Insurance is important to safeguard project from natural damages.",
          "Estimated installation time is within 45 to 90 days from receipt of material at site based on the size of the project, subjected to completion of your scope preparation and naturally conditions.",
          "On Subsidy approval, subsidy amount will be directly credited into your bank account. KBPL has no control over any process once your file is processed from our end.",
          "KBPL's offers are subject to terms and limitations. KBPL retains the right to make adjustments to offers.",
          "KBPL is not responsible for disapproval of subsidy or loan on any grounds.",
          "Any contention to Law will be subject to Pune Jurisdiction only.",
          "Above quote is valid for 20 days from the date of generation.",
        ]
      : null;

  // Merge into one list
  // const finalTerms = [...specialTerms, ...defaultTerms];

  const finalTerms = quotationTerms
    ? quotationTerms
    : [...specialTerms, ...defaultTerms];

  return (
    <div className="mt-2">
      <b className="fs-3">Terms & Conditions:</b>

      <ol className="fs-5 mt-1">
        {finalTerms.map((term, index) => (
          <li key={index}>{term}</li>
        ))}
      </ol>
    </div>
  );
};

export default NotesFooter;
